import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CredentialTransitionProcess, CredentialTransitionLookups } from '../../models/credentialTransitionProcess';
import { EmployeeTransitionAdvance, EmployeeTransitionDetail, EmployeeTransitionFilter, EmployeeTransitionLookups,
  EmployeeTransitionRow, EmployeeTransitionUpdate } from '../../models/credentialTransitionManagement';
import { PagingResultsModel } from '../../models/pagingResultsModel';

@Injectable({ providedIn: 'root' })
export class CredentialTransitionManagementService
{
  private readonly url = `${environment.apiServer.webApiURL}/CredentialTransitionManagement`;

  constructor(private http: HttpClient)
  {
  }

  list()
  {
    return this.http.get<CredentialTransitionProcess[]>(this.url);
  }

  lookups()
  {
    return this.http.get<CredentialTransitionLookups>(`${this.url}/Lookups`);
  }

  save(process: CredentialTransitionProcess)
  {
    return this.http.post<CredentialTransitionProcess>(this.url, process);
  }

  controls(process: CredentialTransitionProcess, control: 'enabled' | 'paused')
  {
    return this.http.post<CredentialTransitionProcess>(`${this.url}/${process.id}/Controls`,
      {
        control,
        value: !process[control],
        expectedValue: process[control]
      });
  }

  delete(id: number)
  {
    return this.http.delete(`${this.url}/${id}`);
  }

  transitions(filter: EmployeeTransitionFilter)
  {
    const params = {
      includeInactive: filter.includeInactive.toString(),
      page: filter.page.toString(),
      pageSize: filter.pageSize.toString(),
      sortField: filter.sortField,
      sortOrder: filter.sortOrder.toString()
    };
    if (filter.userID != null)
      params['userID'] = filter.userID.toString();
    if (filter.campusID != null)
      params['campusID'] = filter.campusID.toString();
    if (filter.processID != null)
      params['processID'] = filter.processID.toString();

    return this.http.get<PagingResultsModel<EmployeeTransitionRow>>(`${this.url}/Transitions`, { params });
  }

  transitionLookups()
  {
    return this.http.get<EmployeeTransitionLookups>(`${this.url}/TransitionLookups`);
  }

  transition(id: number)
  {
    return this.http.get<EmployeeTransitionDetail>(`${this.url}/Transitions/${id}`);
  }

  updateTransition(id: number, model: EmployeeTransitionUpdate)
  {
    return this.http.post<EmployeeTransitionDetail>(`${this.url}/Transitions/${id}`, model);
  }

  advanceTransition(id: number, model: EmployeeTransitionAdvance)
  {
    return this.http.post<EmployeeTransitionDetail>(`${this.url}/Transitions/${id}/Advance`, model);
  }
}
